import { SIMILAR_UNIT_STAGE_LABEL, type SimilarUnitStage } from "./constants";

const STAGE_ORDER = new Map<SimilarUnitStage, number>(
  (Object.keys(SIMILAR_UNIT_STAGE_LABEL) as SimilarUnitStage[]).map(
    (stage, index) => [stage, index]
  )
);

const byStageOrder = (a: SimilarUnitStage, b: SimilarUnitStage) =>
  (STAGE_ORDER.get(a) ?? 0) - (STAGE_ORDER.get(b) ?? 0);

/** "Any" with nothing picked, the stage name for one, "First +N" for several. */
export const getSimilarUnitChipLabel = (
  stages: SimilarUnitStage[] | undefined
): string => {
  if (!stages?.length) return "Any";
  const [first] = [...stages].sort(byStageOrder);
  const label = SIMILAR_UNIT_STAGE_LABEL[first] ?? first;
  return stages.length === 1 ? label : `${label} +${stages.length - 1}`;
};

/** Adds or removes one stage, keeping the funnel order. */
export const toggleSimilarUnitStage = (
  stages: SimilarUnitStage[] | undefined,
  stage: SimilarUnitStage
): SimilarUnitStage[] => {
  const current = stages ?? [];
  return current.includes(stage)
    ? current.filter((item) => item !== stage)
    : [...current, stage].sort(byStageOrder);
};
